import { FC, ReactNode } from 'react'
import cn from './index.module.css'
import FieldWrapper from '../FieldWrapper/FieldWrapper'
import classNames from 'classnames'
import BasicTextField, {
  IBasicTextField,
} from '../BasicTextField/BasicTextField'

interface ITextField extends IBasicTextField {
  label?: string
  description?: string
}

const TextField: FC<ITextField> = ({
  label,
  description,
  isInvalid,
  className,
  ...props
}) => {
  return (
    <FieldWrapper label={label} description={description} isInvalid={isInvalid}>
      <BasicTextField
        className={classNames(cn.input, isInvalid && cn.invalid, className)}
        {...props}
      />
    </FieldWrapper>
  )
}

export default TextField
